module.exports = __webpack_public_path__ + "img/偷笑.b5385c47.png";